import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Layouts
import MainLayout from './components/layout/MainLayout';

// Pages (lazy loaded)
const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Suspense
          fallback={
            <div className='flex h-screen w-full items-center justify-center'>
              <div className='h-16 w-16 animate-spin rounded-full border-b-4 border-primary-cold'></div>
            </div>
          }
        >
          <Routes>
            <Route path='/' element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path='servicios' element={<Services />} />
              <Route path='nosotros' element={<About />} />
              <Route path='contacto' element={<Contact />} />
              <Route path='*' element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;
